import { listProjectItems } from '@wix/ambassador-portfolio-project-items-v1-project-item/http';
const LIMIT = 100;
export const fetchPortfolioProjectItems = async (httpClient, errorHandler, projectId) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allItems = [];
  await withErrorHandler(async () => {
    let offset = 0;
    let hasMore = true;
    do {
      const {
        data: {
          items,
          metadata
        }
      } = await httpClient.request(listProjectItems({
        paging: {
          limit: LIMIT,
          offset
        },
        projectId
      }));
      allItems.push(...(items ?? []));
      offset += LIMIT;
      hasMore = (metadata == null ? void 0 : metadata.hasNext) ?? false;
    } while (hasMore);
  }, {
    errorCodesMap: {}
  });
  return allItems;
};
//# sourceMappingURL=fetch-portfolio-project-items.js.map